import { render, staticRenderFns } from "./CoveredMaresTable.vue?vue&type=template&id=2c53b0b4&scoped=true&"
import script from "./CoveredMaresTable.vue?vue&type=script&lang=ts&"
export * from "./CoveredMaresTable.vue?vue&type=script&lang=ts&"
import style0 from "./CoveredMaresTable.vue?vue&type=style&index=0&id=2c53b0b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53b0b4",
  null
  
)

export default component.exports